
				import path from "node:path";
				const scriptPath = path.resolve(__dirname, "..", "wrangler-dist/ProxyWorker.js");
				export default scriptPath;
            